var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-layout",class:{
        'is-from-crm-applet': _vm.isFromCrmApplet(),
        'is-use-tabbar': _vm.isUseTabbar(),
    }},[_c('NavBar'),_c('div',{staticClass:"mobile-layout__content"},[_c('transition',{attrs:{"name":"el-fade-in-linear","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer'),_c('Capsule')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }